import { NavLink } from 'react-router-dom';

export function DemoDockNav() {
  return (
    <nav aria-label="Demo Dock navigation" className="demo-dock-nav">
      <NavLink to="/projects/demodock" end>
        Demo
      </NavLink>
      <NavLink to="/projects/demodock/skus">Plans &amp; credits</NavLink>
    </nav>
  );
}
